export default __webpack_public_path__ + "static/media/mortgage-eligibility.5e7b232a.svg";